(function () {
  'use strict';

  if (!document.getElementById('aelo-shopify-header-alignment')) {
    var headerStyle = document.createElement('style');
    headerStyle.id = 'aelo-shopify-header-alignment';
    headerStyle.textContent = [
      '#header-group .announcement-bar__slide,#header-group .announcement-bar__text{text-align:center;margin-inline:auto}',
      '@media (min-width:990px){#header-component .header__row--top .header__columns{position:relative}',
      '#header-component .header__row--top .header__column--center{position:absolute;inset-block-start:50%;inset-inline-start:50%;transform:translate(-50%,-50%);inline-size:max-content;z-index:3;display:flex;justify-content:center;pointer-events:none}',
      '#header-component .header__row--top .header__column--center .header-logo{pointer-events:auto}}'
    ].join('');
    document.head.appendChild(headerStyle);
  }

  var roots = document.querySelectorAll('[data-aelo-product-pdp]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var form = root.querySelector('.aelo-product-form');
    var optionButtons = root.querySelectorAll('[data-aelo-purchase-option]');
    var sellingPlanInput = root.querySelector('[data-aelo-selling-plan-input]');
    var variantInput = root.querySelector('[data-aelo-variant-input]');
    var stickyButton = root.querySelector('[data-aelo-sticky-submit]');
    var mainSubmit = root.querySelector('[data-aelo-main-submit]');
    var selectedLabel = root.querySelector('[data-aelo-selected-label]');
    var productId = Number(root.getAttribute('data-aelo-product-id') || 0);
    var checkoutEnabled = root.getAttribute('data-aelo-checkout-enabled') === 'true';

    function removeRetiredMembershipCartLine() {
      if (!productId || !window.fetch) return;

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to inspect cart');
          return response.json();
        })
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (item) {
            var allocation = item.selling_plan_allocation;
            var isRetiredMembership = Number(item.product_id) === productId
              && allocation
              && !checkoutEnabled;

            if (isRetiredMembership) updates[item.key] = 0;
          });

          if (!Object.keys(updates).length) return null;

          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function (response) {
            if (!response.ok) throw new Error('Unable to remove retired membership');
            window.location.reload();
          });
        })
        .catch(function () {
          // Keep the product page usable if Shopify's cart endpoint is unavailable.
        });
    }

    removeRetiredMembershipCartLine();

    function getAttributionCode() {
      if (window.AeloReferralAttribution && window.AeloReferralAttribution.code) {
        return window.AeloReferralAttribution.code;
      }

      try {
        var params = new URLSearchParams(window.location.search);
        return params.get('aelo_ref') || params.get('code') || params.get('invite') || '';
      } catch (_) {
        return '';
      }
    }

    function withReferralCode(href) {
      if (!href) return href;
      var code = getAttributionCode();
      if (!code) return href;

      try {
        var url = new URL(href, window.location.origin);
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return href;
        if (!url.searchParams.get('aelo_ref')) url.searchParams.set('aelo_ref', code);

        if (url.origin === window.location.origin) {
          return url.pathname + url.search + url.hash;
        }

        return url.toString();
      } catch (_) {
        return href;
      }
    }

    function navigateWithAttribution(href) {
      var target = withReferralCode(href);
      if (!target) return;

      if (window.AeloReferralAttribution && typeof window.AeloReferralAttribution.refresh === 'function') {
        var navigated = false;
        var navigate = function () {
          if (navigated) return;
          navigated = true;
          window.location.href = target;
        };

        Promise.resolve(window.AeloReferralAttribution.refresh()).then(navigate).catch(navigate);
        window.setTimeout(navigate, 350);
        return;
      }

      window.location.href = target;
    }

    function setOption(button) {
      var option = button.getAttribute('data-aelo-purchase-option');
      var sellingPlan = button.getAttribute('data-aelo-selling-plan') || '';
      var variantId = button.getAttribute('data-aelo-variant-id') || '';
      var submitLabel = button.getAttribute('data-aelo-submit-label') || 'Add to cart';
      var selectedText = button.getAttribute('data-aelo-selected-text') || submitLabel;
      var externalUrl = button.getAttribute('data-aelo-external-url') || '';
      var optionUnavailable = button.hasAttribute('data-aelo-option-unavailable');
      if (optionUnavailable) submitLabel = 'Trial checkout opening soon';

      optionButtons.forEach(function (candidate) {
        candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
      });

      if (selectedLabel) selectedLabel.textContent = selectedText;
      if (sellingPlanInput) {
        if (sellingPlan) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = sellingPlan;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }
      }
      if (variantInput && variantId) variantInput.value = variantId;

      if (mainSubmit) {
        mainSubmit.textContent = submitLabel;
        mainSubmit.setAttribute('data-aelo-external-url', externalUrl);
        mainSubmit.disabled = optionUnavailable || mainSubmit.hasAttribute('data-aelo-product-unavailable');
      }
      if (stickyButton) {
        stickyButton.textContent = submitLabel;
        stickyButton.setAttribute('data-aelo-external-url', externalUrl);
        stickyButton.disabled = optionUnavailable || stickyButton.hasAttribute('data-aelo-product-unavailable');
      }

      root.setAttribute('data-aelo-selected-option', option || 'subscription');
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setOption(button);
      });
    });

    function submitForm() {
      var activeButton = root.querySelector('[data-aelo-purchase-option][aria-pressed="true"]');
      if (!activeButton) return;
      var externalUrl = activeButton && activeButton.getAttribute('data-aelo-external-url');
      if (externalUrl) {
        navigateWithAttribution(externalUrl);
        return;
      }
      if (activeButton && activeButton.hasAttribute('data-aelo-option-unavailable')) return;
      if (window.AeloReferralAttribution && typeof window.AeloReferralAttribution.refresh === 'function') {
        void window.AeloReferralAttribution.refresh();
      }
      if (form) form.requestSubmit();
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', submitForm);
    }

    if (mainSubmit) {
      mainSubmit.addEventListener('click', function (event) {
        var externalUrl = mainSubmit.getAttribute('data-aelo-external-url');
        if (!externalUrl) return;
        event.preventDefault();
        navigateWithAttribution(externalUrl);
      });
    }

    var defaultOption = root.querySelector('[data-aelo-purchase-option][aria-pressed="true"]');
    if (defaultOption) setOption(defaultOption);
  });
})();
